<template>
  <el-form-item :label="$attrs.label" :prop="$attrs.name" class="elsa-input" :ref="$attrs.name">
    <template slot="label" v-if="information">
      {{ $attrs.label }}
      <el-tooltip v-if="information" :content="information" popper-class="white-space-pre-line">
        <i class="el-icon-info" />
      </el-tooltip>
    </template>
    <div>
      <custom-input-number v-bind="$attrs" v-model="modelProp" ref="input" v-on:blur="handleBlur" /><span class="follow-info"> {{ followInfo }}</span>
    </div>
  </el-form-item>
</template>

<script>
import CustomInputNumber from '@/components/common/custom/input-number'
export default {
  name: 'ElsaInput',
  components: { CustomInputNumber },
  props: ['value', 'followInfo', 'information'],
  computed: {
    modelProp: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    },
    handleBlur() {
      this.$emit('blur')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/colors';
.elsa-input {
  &::v-deep .el-input .el-input__inner {
    background: #ffffff;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: 'SF Pro Display', sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    opacity: 0.6;
    height: 52px;
    padding-right: 40px !important;
  }

  &::v-deep .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
    cursor: not-allowed;
  }
  .follow-info {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: $black;
    margin-left: 12px;
  }

  &::v-deep {
    .el-input-number {
      width: 152px !important;
    }
    span.el-input-number__increase {
      background-color: transparent;
      border: none !important;
      transform: translateY(4px);
      i {
        font-size: 20px;
        color: $black;
      }
    }

    span.el-input-number__decrease {
      transform: translateY(3px);
      background-color: transparent;
      border: none !important;
      i {
        font-size: 20px;
        color: $black;
      }
    }
  }

  .el-tooltip.el-icon-info {
    margin-left: 3px;
    color: #546873 !important;
    font-size: 14px !important;
  }
}
</style>
